import React, { useState } from "react";
import toast from "react-hot-toast";
import classNames from "classnames";

import { CognitoAuthApi } from "../../services/Api/CognitoAuthApi";
import { Label, Input, Button, Loader, WhiteLabel } from "../../components";
import { Sendum } from '../../Sendum';

import classes from "./LoginComponent.module.scss";


export const LoginComponent = () => {
	const [username, setUsername] = useState<string>("");
	const [pwd, setPwd] = useState<string>("");
	const [isLoading, setLoading] = useState<boolean>(false);

	const usernameInputOnChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
		setUsername(event.target.value || "");
	};

	const pwdInputOnChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPwd(event.target.value || "");
	};

	const loginButtonOnClickHandler = () => {
		if (!isLoading) {
			setLoading(true);

			new CognitoAuthApi().login(username, pwd)
				.then(two => {
					Sendum.getBrowserHistory().push('/');
					// window.location.href = "/";
				})
				.catch(error => {
					if (error instanceof Error) {
						toast.error(error.message);
					}
					setLoading(false);
				});
		}
	};

	const forgotPwdBtnOnClickHandler = () => {
		Sendum.getBrowserHistory().push('/forgot-password');
	}

	return (
		<div className={classes.login}>
			<div className={classes.login__column}>
				<WhiteLabel/>
				<div className={classes.login__title}>Login</div>
				<form className={classNames(classes.login__form, classes.form)}>
					{!!isLoading && (<Loader className={classes.form__loading} />)}
					<div className={classes.form__column}>
						<Label text={"Email *"} >
							<Input
								placeholder={"Email *"}
								value={username}
								onChange={usernameInputOnChangeHandler}
								name={username}
								autoComplete={"on"}
								type={"text"}
							/>
						</Label>
						<Label text={"Password *"}>
							<Input
								placeholder={"Password *"}
								value={pwd}
								onChange={pwdInputOnChangeHandler}
								name={"password"}
								autoComplete={"on"}
								type={"password"}
							/>
						</Label>
						<Button className={classes.form__button} title={"Login"} onClick={loginButtonOnClickHandler} />
					</div>
				</form>
				<div className={classes.login__forgot} onClick={forgotPwdBtnOnClickHandler}>Forgot your password?</div>
			</div>
		</div>
	);
};
